module.exports = __webpack_public_path__ + "static/img/展馆智能中控.650fc91f.png";